import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useMemo } from 'react'
import * as React from 'react'
import { groupBy, sortBy } from 'lib/array/arrayUtils'
import AccommodationCalendarMonthGrid from './AccommodationCalendarMonthGrid'
import Heading from 'LuxKit/Typography/Heading'
import type {
  AccommodationCalendarYearSelectHandler,
  AccommodationMonthView,
  AccommodationYearView,
} from './AccommodationCalendar.types'

export type {
  AccommodationCalendarYearSelectHandler,
  AccommodationMonthView,
  AccommodationYearView,
} from './AccommodationCalendar.types'

interface Props {
  views: Array<AccommodationMonthView>
  onSelect?: AccommodationCalendarYearSelectHandler
  className?: string
  priceType?: 'default' | 'member'
}

function AccommodationCalendarMonthPicker(props: Props) {
  const { views, className, onSelect, priceType } = props

  const sortedViews = useMemo<Array<AccommodationYearView>>(() => {
    const yearViews = groupBy(views, view => view.year).entries().map<AccommodationYearView>(([year, views]) => {
      return {
        year,
        months: views,
      }
    }).toArray()
    return sortBy(yearViews, view => view.year, 'asc')
  }, [views])

  return <VerticalSpacer className={className} gap={20}>
    {sortedViews.map(view => <VerticalSpacer gap={12} key={view.year}>
      <Heading variant="heading5">{view.year}</Heading>
      <AccommodationCalendarMonthGrid
        monthViews={view.months}
        onSelect={onSelect}
        priceType={priceType}
      />
    </VerticalSpacer>)}
  </VerticalSpacer>
}

export default AccommodationCalendarMonthPicker
